"use strict";

import Axios from "axios";
import configuration from "../../configuration";

const url = configuration.apiHost;

export default class additionalService {

  static async getAll() {
    try {
      // throw new Error("Errado seu mané")
      let additional = await Axios.get(url + "additionals_work");
      return additional.data;
    } catch (error) {
      throw new Error(error);
    }
  } // getAll();

  static async save(additional) {
    try {
      let additionalSaved = await Axios.post(url + "additionals_work", additional);
      return additionalSaved.data;
    } catch (error) {
      throw new Error(error);
    }
  } // save()

  static async edit(additional) {
    try {
      await Axios.put(url + "additionals_work", additional);
    } catch (error) {
      throw new Error(error);
    }
  } // edit()

  static async remove(additional) {
    try {
      await Axios.delete(url + "additionals_work", {
        data: additional
      });
    } catch (error) {
      throw new Error(error);
    }
  } // remove()

} // class



// WEBPACK FOOTER //
// ./src/service/AdditionalWorkService.js